<template>
    <div class="bean background-supplement-no-title-layout">
        <div class="layout-content" v-loading="loading">
            <div class="bean-amount">
                豆豆数量：<span>{{ remainValue }}（粒）</span>
                <div class="cashing"
                     @click="detailDialog">答疑豆使用说明>></div>
            </div>
            <ul class="bean-list">
                <li v-for="(list, index) in amounts"
                    :key="index">
                    <div class="list-left">
                        <div>
                            <el-popover placement="bottom-start"
                                        width="auto"
                                        trigger="hover"
                                        :content="list.remark">
                                <span slot="reference"
                                      class="cost-space-text">
                                    <span v-if="list.moneyAmount < 0"
                                          class="pay">{{ list.remark }}</span>
                                    <span v-else
                                          class="in">{{ list.remark }}</span>
                                </span>
                            </el-popover>
                            <p> {{ formatDate(list.time) }}</p>
                        </div>
                    </div>
                    <div class="list-right">
                        <span v-if="list.amount < 0"
                              class="pay">{{ list.amount }}</span>
                        <span v-else
                              class="income">{{ list.amount }}</span>
                    </div>
                </li>
            </ul>
            <div class="page">
                <el-pagination v-if="total > 20"
                                style="text-align:center"
                               @current-change="handleCurrentChange"
                               :current-page.sync="currentPage"
                               :page-size="20"
                               layout="prev, pager, next"
                               :total="total"
                               class="page">
                </el-pagination>
            </div>
        </div>
        <div class="dialog">
            <el-dialog title="购买答疑豆"
                       :visible.sync="dialogVisible"
                       width="526px">
                <!-- <div class="notice"><i></i>
                    答疑豆用户答题和提问中，购买兑换后不可返现，购买费用将直接从学费月中扣除
                </div> -->
                <div class="bean-dialog-con"
                     v-for="item in goods"
                     :key="item.no"
                     @click="getPrice(item)"
                     :class="{active: goodsNo === item.no}">
                    <p class="top">{{ item.name }}<span><label>{{ item.price }}</label>元</span></p>
                    <p class="bot">{{ item.quantity }}粒豆<span v-if="item.originalPrice > 0">原价{{ item.originalPrice }}元
                        </span></p>
                    <label :class="{selected: goodsNo === item.no}"></label>
                </div>
                <div class="notice">
                    <div class="notice-title">
                        <i></i>
                        答疑豆使用规则
                    </div>
                    <div class="notice-main"
                         v-for="item in noticeInfo"
                         :key="item">{{ item }}</div>
                </div>
                <span class="wait-pay"
                      v-if="payPrice">待支付:<label>￥{{ payPrice }}</label></span>
                <div slot="footer"
                     class="dialog-footer">
                    <el-button type="primary"
                               @click="handleCancel"
                               class="cancel">取消</el-button>
                    <el-button type="primary"
                               @click="handlePayConfirm()"
                               class="sure">确认</el-button>
                </div>
            </el-dialog>
            <el-dialog title="支付确认"
                       :visible.sync="dialogPay">
                <div class="pay">
                    将从学费余额中扣除¥{{ payPrice }}，支付后不可返现
                </div>
                <div slot="footer"
                     class="dialog-footer">
                    <el-button type="primary"
                               @click="dialogPay = false"
                               class="cancel">取消</el-button>
                    <el-button type="primary"
                               @click="handleSubmit()"
                               class="sure">确认</el-button>
                </div>
            </el-dialog>
        </div>
        <el-dialog title="答疑豆使用说明"
                   :visible.sync="isShow"
                   top="22vh"
                   width="573px" class="custom">
            <div class="text">
                1、使用说明：答疑豆是供学生找老师解答问题使用的，通过在线答疑列表可以寻找自己年级、科目的合适老师发起1对1答疑连线，老师接受后即可开始答疑！
            </div>
            <div class="text">
                2、扣除规则：根据发起的答疑连线次数扣除，一次答疑建议问一个问题，答疑结束后扣除2粒答疑豆，如果觉得老师解答的好还可以奖励老师更多豆豆！
            </div>
            <div class="text">
                3、有效期说明：答疑豆的有效期为一年，即每年的12月31日24:00开始逐步清理1年前获取但未使用的答疑豆，比如2018年12月31日24:00会清空掉2017年12月31日24:00之前获取的但是现在还没有消费掉的答疑豆。
            </div>
            <div slot="footer"
                 class="dialog-footer">
                <el-button type="primary"
                           @click="isShow = false"
                           class="btn-sure dialog-btn-common">我知道了</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import { mapActions } from 'vuex';
import Moment from 'moment';
const noticeInfo = [
    '1. 使用说明：答疑豆是供学生找老师解答问题使用的，通过在线答疑列表可以寻找自己年级、科目的合适老师发起1对1答疑连线，老师接受后即可开始答疑！',
    '2. 扣除规则：根据发起的答疑连线次数扣除，一次答疑建议问一个问题，答疑结束后扣除2粒答疑豆，如果觉得老师解答的好还可以奖励老师更多豆豆！',
    '3. 购买说明：答疑豆没有过期限制，只供答疑使用，购买后不可退返、不可提现！'
];
export default {
    data() {
        return {
            noticeInfo,
            flag: true,
            loading: false,
            dialogPay: false, // 确认支付弹窗
            dialogVisible: false,
            currentPage: 1,
            start: 0,
            limit: 20,
            total: 0,
            amounts: [],
            goods: [],
            warnMsg: '',
            btnDisabled: false,
            payPrice: '', // 付款金额
            goodsNo: '', // 商品编号
            remainValue: 0, // 豆豆数量
            isShow: false
        };
    },
    beforeMount() {
        this.getBeans();
    },
    methods: {
        ...mapActions(['PAYMENT_GET_GOODS', 'PAYMENT_PACKAGE_GOOD']),
        detailDialog() {
            this.isShow = true;
        },
        getBeans() {
            if (this.flag) {
                this.flag = false;
                this.loading = true;
                let limit = this.limit;
                this.$http
                    .get('/v1/payments/study-beans/records', {
                        params: {
                            start: (this.currentPage - 1) * limit,
                            limit
                        }
                    })
                    .then(resp => this.$checkResp(resp, {})).then(data => {
                        if (data) {
                            this.amounts = data.records;
                            this.remainValue = data.remainValue || 0;
                            this.total = data.total;
                        }
                    }).catch(err => {
                        this.$handleError(err.msg);
                        this.btnDisabled = true;
                    }).finally(() => {
                        this.flag = true;
                        this.loading = false;
                    });
            }
        },
        handleCurrentChange(page) {
            this.currentPage = page;
            this.getBeans();
        },
        // buyBeans() {
        //     this.dialogVisible = true;
        //     this.PAYMENT_GET_GOODS().then(data => {
        //         if (data.studyBean) {
        //             this.goods = data.studyBean.map(item => {
        //                 item.originalPrice = item.originalPrice ? item.originalPrice / 100 : -1;
        //                 item.price = (item.price / 100).toFixed(2);
        //                 return Object.assign({}, item);
        //             });
        //         }
        //     });
        // },
        handleSubmit() {
            if (this.payPrice !== '' && this.flag) {
                this.flag = false;
                this.$http.post('/v1/payments', { goodsType: 2,
                    goodsNo: this.goodsNo,
                    copies: 1,
                    payThrough: 1,
                    deviceType: 3
                }).then(resp => this.$checkResp(resp, {})).then(data => {
                    if (data.complete) {
                        this.dialogPay = false;
                        this.dialogVisible = false;
                        this.flag = true;
                        this.getBeans();
                        this.$message.info('购买成功！');
                    }
                }).catch(err => {
                    if (err.code === 1010) { // 学费不足
                        this.$handleError('支付失败 余额不足');
                    } else {
                        this.$handleError(err.msg);
                    }
                }).finally(() => {
                    this.flag = true;
                });
            }
        },
        formatDate(date) {
            return date ? Moment(date).format('YYYY-MM-DD HH:mm:ss') : '';
        },
        getPrice(item) {
            this.payPrice = item.price;
            this.goodsNo = item.no;
        },
        handleCancel() {
            this.dialogVisible = false;
            this.payPrice = '';
            this.goodsNo = '';
        },
        handlePayConfirm() {
            if (this.payPrice && this.goodsNo) {
                this.$router.push({
                    name: 'charge@package',
                    query: {
                        studyNo: this.goodsNo
                    }
                });
            } else {
                this.$message.warning('请选择购买项');
            }
        }
    }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.custom {
    /deep/ .el-dialog__title {
        font-size: 16px;
        color: #4e3f3c;
    }
}

.layout-content {
    padding: 30px;
}

.bean-amount {
    width: 100%;
    line-height: 38px;
    background: url("../../../assets/images/common/bean_img_bg.png") no-repeat center;
    background-size: contain;
    height: 100px;
    font-size: 14px;
    display: flex;
    margin-bottom: 30px;
    position: relative;
    padding: 30px 53px 25px 64px;
    color: #fff;

    span {
        font-size: 24px;
        margin: 0 10px;
    }

    .cashing {
        position: absolute;
        right: 53px;
        top: 30px;
        font-size: 12px;
        cursor: pointer;
    }

    /deep/ .el-button--primary {
        border: none;
        padding: 9px 11px;
    }
}

.bean-list {
    padding: 0 12px;

    li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 21px;
        margin-bottom: 19px;
    }

    .cost-space-text {
        font-size: 14px;
        color: #4e3f3c;
        line-height: 20px;
        display: inline-block;
    }

    p {
        margin-top: 5px;
        font-size: 12px;
        color: #bfb2b0;
        line-height: 17px;
    }

    .list-right {
        font-size: 14px;
        color: #333;
    }

    .pay {
        color: #4e3f3c;
    }

    .income {
        color: #4e3f3c;
    }
}

.page {
    margin-top: 30px;
    width: 100%;
    text-align: right;
}

.dialog {
    .wait-pay {
        position: absolute;
        bottom: 30px;
        left: 30px;
        font-size: 14px;
        color: #333;
        display: flex;
        line-height: 20px;

        label {
            font-size: 20px;
            color: #e55b45;
            margin-left: 10px;
        }
    }

    .bean-dialog-con {
        border: 1px solid #e7e7e7;
        border-radius: 2px;
        // width: 450px;
        height: 60px;
        margin-bottom: 10px;
        padding: 10px 22px;
        position: relative;
    }

    .bean-dialog-con.active {
        border: 1px solid #1daef8;
    }

    p {
        height: 20px;
        line-height: 20px;
    }

    p.top {
        font-size: 14px;
        color: #000;

        span {
            float: right;
            display: flex;

            label {
                color: #e55b45;
            }
        }
    }

    p.bot {
        font-size: 12px;
        color: #4d4d4d;

        span {
            float: right;
            color: #999;
            font-size: 12px;
            text-decoration: line-through;
        }
    }

    .pay {
        font-size: 14px;
        color: #333;
    }

    .selected {
        background: url(../../../assets/images/record/selected.png) no-repeat right bottom;
        background-size: contain;
        width: 20px;
        height: 20px;
        // display: none;
        position: absolute;
        right: 0;
        bottom: 0;
    }
}

.bean {
    /deep/ .el-dialog__header {
        padding: 20px 20px 29px 29px;
    }

    /deep/ .el-dialog__body {
        padding: 0 30px 23px;
    }

    .dialog {
        .notice {
            font-family: PingFangSC-Regular;
            color: #8898af;

            & > div {
                padding-left: 22px;
                font-size: 12px;
                line-height: 17px;
            }

            .notice-title {
                height: 18px;
                position: relative;

                i {
                    background: url(../../../assets/images/common/nav_Prompt.png) no-repeat center;
                    background-size: contain;
                    width: 12px;
                    height: 14px;
                    display: inline-block;
                    position: absolute;
                    left: 0;
                    top: 1px;
                }
            }

            .notice-main {
                margin-top: 8px;
            }

            .notice-main:nth-child(2) {
                margin: 0;
            }
        }

        .cancel {
            border-radius: 16px;
        }

        .sure {
            background-image: linear-gradient(-90deg, #0ac4ff 0%, #459aff 100%);
            box-shadow: 0 4px 10px 0 rgba(29, 174, 248, 0.43);
            border-radius: 16px;
        }
    }

    /deep/ .el-dialog__footer {
        padding: 0 30px 23px;
    }
}

.text {
    font-size: 14px;
    color: #766864;
    letter-spacing: 0;
    line-height: 26px;
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/RecordBean.vue